import axiosConfig from "./axiosConfig";

export const searchArticle = async (
    search = "",
    page = 1,
    limit = 10,
    order = "desc"
) => {
    try {
        const url = `v1/articles/publier?limit=${limit}&page=${page}&order=${order}&search=${encodeURIComponent(search)}`;
        const response = await axiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('Error searching articles:', error);
        throw error;
    }
};

export const getAllArticlePublished = async (page = 1, limit = 10) => {
    try {
        let url = `v1/articles/publier?limit=${limit}&page=${page}&order=desc`;

        const response = await axiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching articles:', error);
        throw error;
    }
};

export const getFourNewArticle = async () => {
    try {
        const response = await axiosConfig.get('v1/articles/publier?limit=4&page=1&order_by=date_pub_art&order=desc');
        return response.data;
    } catch (error) {
        console.error('Error fetching rubriques:', error);
        throw error;
    }
};

export const getArticlePublishedForRubrique = async (page = 1, limit = 10) => {
    try {
        let url = `v1/articles/publier?limit=${limit}&page=${page}&order=desc`;

        const response = await axiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching articles:', error);
        throw error;
    }
}

/**
 * Récupère un article via son slug.
 * @param {string} slug - Slug de l'article à récupérer.
 */
export const getArticleBySlug = async (slug) => {
    try {
        const response = await axiosConfig.get(`v1/articles/${slug}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching rubriques:', error);
        throw error;
    }
};

export const submitArticle = async (formData) => {
    try {
        const response = await axiosConfig.post('v2/articles/submission', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        // Récupère le message d’erreur du backend si disponible
        let errorMsg = "Une erreur s'est produite lors de la soumission.";
        // Axios: error.response.data.message ou error.response.data.error ou error.message
        if (error.response) {
            if (error.response.data?.message) {
                errorMsg = error.response.data.message;
            } else if (error.response.data?.error) {
                errorMsg = error.response.data.error;
            } else if (typeof error.response.data === "string") {
                errorMsg = error.response.data;
            } else if (error.response.status === 500) {
                errorMsg = "Erreur interne du serveur (500)";
            }
        } else if (error.message) {
            errorMsg = error.message;
        }
        // Affiche l’erreur dans la console pour debug
        console.error('Error submitting article:', errorMsg, error);
        // Renvoie l’erreur sous forme d’objet avec le message
        throw new Error(errorMsg);
    }
};